export default __webpack_public_path__ + "static/media/schoolAndAthleteRegistration.cad40042.jpg";